import * as yup from 'yup';

export const FilterConf = {
  schema: yup.object({}),
  initialState: {
    value: {},
  },
  fields: [],
  query: {
    keys: [],
  },
};
